import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import LoadableButton from "../../../components/button/LoadableButton";
import {
  GetDocumentApi,
  SubmitSignatureApi,
} from "../../../api/request/dashboard/dashboard";
import SignPdf from "../../../components/pdfSignature/SignPdf";

const SignatureReport = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [document, setDocument] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [signedPdf, setSignedPdf] = useState(null);
  const [isUploadFileLoading, setIsUploadFileLoading] = useState(false);

  const getDocumentData = async () => {
    setIsLoading(true);
    try {
      const { data } = await GetDocumentApi(id);
      if (data?.status) setDocument(data?.data);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) getDocumentData();
  }, [id]);

  const handleSigningComplete = (signedPdf, signaturePositions) => {
    const isSignPending = signaturePositions.some((item) => !item.signature);
    if (isSignPending) return setSignedPdf(null);
    setSignedPdf(signedPdf);
  };

  const submitSignature = async () => {
    if (!signedPdf) return;
    try {
      setIsUploadFileLoading(true);
      const params = {
        document_id: id,
        file: signedPdf,
      };
      const apiHeader = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      const { data } = await SubmitSignatureApi(params, apiHeader);
      if (data?.status) {
        toast.success(data?.message);
        navigate("/dashboard");
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsUploadFileLoading(false);
    }
  };

  return (
    <div className="bg-white border rounded-xl p-5">
      <div className="max-w-fit overflow-auto">
        {document?.path && document?.positions?.length && (
          <SignPdf
            pdfUrl={document?.path}
            signaturePositions={document?.positions}
            onSigningComplete={handleSigningComplete}
          />
        )}
      </div>

      <div className="flex gap-3 mt-5">
        <button className="btn-outlined" onClick={() => navigate("/dashboard")}>
          Cancel
        </button>

        <LoadableButton
          type="submit"
          lable="Upload"
          isLoading={isUploadFileLoading}
          loadingLable="Uploading file..."
          onClick={submitSignature}
          disabled={!signedPdf}
        />
      </div>
    </div>
  );
};

export default SignatureReport;
